import { CountyActiveStatus, CountyDefinition } from "../../../commontypes/types";


export const CountyDefinitions: CountyDefinition[] =
  [
    {
      key: "01",
      label: "Atlantic",
      active: CountyActiveStatus.TRUE,
      municipalities: [
        {
          key: "0101",
          label: "Absecon City"
        },
        {
          key: "0102",
          label: "Atlantic City"
        },
        {
          key: "0103",
          label: "Brigantine City"
        },
        {
          key: "0104",
          label: "Buena Boro"
        },
        {
          key: "0105",
          label: "Buena Vista Twp"
        },
        {
          key: "0106",
          label: "Corbin City"
        },
        {
          key: "0107",
          label: "Egg Harbor City"
        },
        {
          key: "0108",
          label: "Egg Harbor Twp"
        },
        {
          key: "0109",
          label: "Estell Manor City"
        },
        {
          key: "0110",
          label: "Folsom Boro"
        },
        {
          key: "0111",
          label: "Galloway Twp"
        },
        {
          key: "0112",
          label: "Hamilton Twp"
        },
        {
          key: "0113",
          label: "Hammonton Town"
        },
        {
          key: "0114",
          label: "Linwood City"
        },
        {
          key: "0115",
          label: "Longport Boro"
        },
        {
          key: "0116",
          label: "Margate City"
        },
        {
          key: "0117",
          label: "Mullica Twp"
        },
        {
          key: "0118",
          label: "Northfield City"
        },
        {
          key: "0119",
          label: "Pleasantville City"
        },
        {
          key: "0120",
          label: "Port Republic City"
        },
        {
          key: "0121",
          label: "Somers Point City"
        },
        {
          key: "0122",
          label: "Ventnor City"
        },
        {
          key: "0123",
          label: "Weymouth Twp"
        }

      ]
    },
    {
      key: "02",
      label: "Bergen",
      active: CountyActiveStatus.FALSE,
      municipalities: [
        {
          key: "0201",
          label: "Allendale Boro"
        },
        {
          key: "0202",
          label: "Alpine Boro"
        },
        {
          key: "0203",
          label: "Bergenfield Boro"
        },
        {
          key: "0204",
          label: "Bogota Boro"
        },
        {
          key: "0205",
          label: "Carlstadt Boro"
        },
        {
          key: "0206",
          label: "Cliffside Park Boro"
        },
        {
          key: "0207",
          label: "Closter Boro"
        },
        {
          key: "0208",
          label: "Cresskill Boro"
        },
        {
          key: "0209",
          label: "Demarest Boro"
        },
        {
          key: "0210",
          label: "Dumont Boro"
        },
        {
          key: "0211",
          label: "Elmwood Park Boro"
        },
        {
          key: "0212",
          label: "E Rutherford Boro"
        },
        {
          key: "0213",
          label: "Edgewater Boro"
        },
        {
          key: "0214",
          label: "Emerson Boro"
        },
        {
          key: "0215",
          label: "Englewood City"
        },
        {
          key: "0216",
          label: "Englewood Cliffs Boro"
        },
        {
          key: "0217",
          label: "Fairlawn Boro"
        },
        {
          key: "0218",
          label: "Fairview Boro"
        },
        {
          key: "0219",
          label: "Fort Lee Boro"
        },
        {
          key: "0220",
          label: "Franklin Lakes Boro"
        },
        {
          key: "0221",
          label: "Garfield City"
        },
        {
          key: "0222",
          label: "Glen Rock Boro"
        },
        {
          key: "0223",
          label: "Hackensack City"
        },
        {
          key: "0224",
          label: "Harrington Park Boro"
        },
        {
          key: "0225",
          label: "Hasbrouck Hghts Boro"
        },
        {
          key: "0226",
          label: "Haworth Boro"
        },
        {
          key: "0227",
          label: "Hillsdale Boro"
        },
        {
          key: "0228",
          label: "Hohokus Boro"
        },
        {
          key: "0229",
          label: "Leonia Boro"
        },
        {
          key: "0230",
          label: "Little Ferry Boro"
        },
        {
          key: "0231",
          label: "Lodi Boro"
        },
        {
          key: "0232",
          label: "Lyndhurst Twp"
        },
        {
          key: "0233",
          label: "Mahwah Twp"
        },
        {
          key: "0234",
          label: "Maywood Boro"
        },
        {
          key: "0235",
          label: "Midland Park Boro"
        },
        {
          key: "0236",
          label: "Montvale Boro"
        },
        {
          key: "0237",
          label: "Moonachie Boro"
        },
        {
          key: "0238",
          label: "New Milford Boro"
        },
        {
          key: "0239",
          label: "North Arlington Boro"
        },
        {
          key: "0240",
          label: "Northvale Boro"
        },
        {
          key: "0241",
          label: "Norwood Boro"
        },
        {
          key: "0242",
          label: "Oakland Boro"
        },
        {
          key: "0243",
          label: "Old Tappan Boro"
        },
        {
          key: "0244",
          label: "Oradell Boro"
        },
        {
          key: "0245",
          label: "Palisades Park Boro"
        },
        {
          key: "0246",
          label: "Paramus Boro"
        },
        {
          key: "0247",
          label: "Park Ridge Boro"
        },
        {
          key: "0248",
          label: "Ramsey Boro"
        },
        {
          key: "0249",
          label: "Ridgefield Boro"
        },
        {
          key: "0250",
          label: "Ridgefield Park Village"
        },
        {
          key: "0251",
          label: "Ridgewood Village"
        },
        {
          key: "0252",
          label: "Riveredge Boro"
        },
        {
          key: "0253",
          label: "Rivervale Twp"
        },
        {
          key: "0254",
          label: "Rochelle Park Twp"
        },
        {
          key: "0255",
          label: "Rockleigh Boro"
        },
        {
          key: "0256",
          label: "Rutherford Boro"
        },
        {
          key: "0257",
          label: "Saddle Brook Twp"
        },
        {
          key: "0258",
          label: "Saddle River Boro"
        },
        {
          key: "0259",
          label: "So Hackensack Twp"
        },
        {
          key: "0260",
          label: "Teaneck Twp"
        },
        {
          key: "0261",
          label: "Tenafly Boro"
        },
        {
          key: "0262",
          label: "Teterboro Boro"
        },
        {
          key: "0263",
          label: "Upper Saddle Riv Boro"
        },
        {
          key: "0264",
          label: "Waldwick Boro"
        },
        {
          key: "0265",
          label: "Wallington Boro"
        },
        {
          key: "0266",
          label: "Washington Twp"
        },
        {
          key: "0267",
          label: "Westwood Boro"
        },
        {
          key: "0268",
          label: "Woodcliff Lake Boro"
        },
        {
          key: "0269",
          label: "Wood Ridge Boro"
        },
        {
          key: "0270",
          label: "Wyckoff Twp"
        }

      ]
    },
    {
      key: "03",
      label: "Burlington",
      active: CountyActiveStatus.FALSE,
      municipalities: [
        {
          key: "0301",
          label: "Bass River Twp"
        },
        {
          key: "0302",
          label: "Beverly City"
        },
        {
          key: "0303",
          label: "Bordentown City"
        },
        {
          key: "0304",
          label: "Bordentown Twp."
        },
        {
          key: "0305",
          label: "Burlington City"
        },
        {
          key: "0306",
          label: "Burlington Twp"
        },
        {
          key: "0307",
          label: "Chesterfield Twp"
        },
        {
          key: "0308",
          label: "Cinnaminson Twp"
        },
        {
          key: "0309",
          label: "Delanco Twp"
        },
        {
          key: "0310",
          label: "Delran Twp"
        },
        {
          key: "0311",
          label: "Eastampton Twp"
        },
        {
          key: "0312",
          label: "Edgewater Park Twp"
        },
        {
          key: "0313",
          label: "Evesham Twp"
        },
        {
          key: "0314",
          label: "Fieldsboro Bor"
        },
        {
          key: "0315",
          label: "Florence Twp"
        },
        {
          key: "0316",
          label: "Hainesport Twp"
        },
        {
          key: "0317",
          label: "Lumberton Twp"
        },
        {
          key: "0318",
          label: "Mansfield Twp"
        },
        {
          key: "0319",
          label: "Maple Shade Twp"
        },
        {
          key: "0320",
          label: "Medford Twp"
        },
        {
          key: "0321",
          label: "Medford Lakes Bor"
        },
        {
          key: "0322",
          label: "Moorestown Twp"
        },
        {
          key: "0323",
          label: "Mount Holly Twp"
        },
        {
          key: "0324",
          label: "Mount Laurel Twp"
        },
        {
          key: "0325",
          label: "New Hanover Twp"
        },
        {
          key: "0326",
          label: "North Hanover Twp"
        },
        {
          key: "0327",
          label: "Palmyra Bor"
        },
        {
          key: "0328",
          label: "Pemberton Bor"
        },
        {
          key: "0329",
          label: "Pemberton Twp"
        },
        {
          key: "0330",
          label: "Riverside Twp"
        },
        {
          key: "0331",
          label: "Riverton Bor"
        },
        {
          key: "0332",
          label: "Shamong Twp"
        },
        {
          key: "0333",
          label: "Southampton Twp"
        },
        {
          key: "0334",
          label: "Springfield Twp"
        },
        {
          key: "0335",
          label: "Tabernacle Twp"
        },
        {
          key: "0336",
          label: "Washington Twp"
        },
        {
          key: "0337",
          label: "Westampton Twp"
        },
        {
          key: "0338",
          label: "Willingboro Twp"
        },
        {
          key: "0339",
          label: "Woodland Twp"
        },
        {
          key: "0340",
          label: "Wrightstown Bor"
        }
      ]
    },
    {
      key: "04",
      label: "Camden",
      active: CountyActiveStatus.TRUE,
      municipalities: [
        {
          key: "0401",
          label: "Audubon Boro"
        },
        {
          key: "0402",
          label: "Audubon Park Boro"
        },
        {
          key: "0403",
          label: "Barrington Boro"
        },
        {
          key: "0404",
          label: "Bellmawr Boro"
        },
        {
          key: "0405",
          label: "Berlin Boro"
        },
        {
          key: "0406",
          label: "Berlin Twp"
        },
        {
          key: "0407",
          label: "Brooklawn Boro"
        },
        {
          key: "0408",
          label: "Camden City"
        },
        {
          key: "0409",
          label: "Cherry Hill Twnshp"
        },
        {
          key: "0410",
          label: "Chesilhurst Boro"
        },
        {
          key: "0411",
          label: "Clementon Boro"
        },
        {
          key: "0412",
          label: "Collingswood Boro"
        },
        {
          key: "0413",
          label: "Gibbsboro Boro"
        },
        {
          key: "0414",
          label: "Gloucester City"
        },
        {
          key: "0415",
          label: "Gloucester Twp"
        },
        {
          key: "0416",
          label: "Haddon Twp"
        },
        {
          key: "0417",
          label: "Haddonfield Boro"
        },
        {
          key: "0418",
          label: "Haddon Heights Boro"
        },
        {
          key: "0419",
          label: "Hi Nella Boro"
        },
        {
          key: "0420",
          label: "Laurel Springs Boro"
        },
        {
          key: "0421",
          label: "Lawnside Boro"
        },
        {
          key: "0422",
          label: "Lindenwold Boro"
        },
        {
          key: "0423",
          label: "Magnolia Boro"
        },
        {
          key: "0424",
          label: "Merchantville Boro"
        },
        {
          key: "0425",
          label: "Mount Ephraim Boro"
        },
        {
          key: "0426",
          label: "Oaklyn Boro"
        },
        {
          key: "0427",
          label: "Pennsauken Twp"
        },
        {
          key: "0428",
          label: "Pine Hill Boro"
        },
        {
          key: "0430",
          label: "Runnemede Boro"
        },
        {
          key: "0431",
          label: "Somerdale Boro"
        },
        {
          key: "0432",
          label: "Stratford Boro"
        },
        {
          key: "0433",
          label: "Tavistock Boro"
        },
        {
          key: "0434",
          label: "Voorhees Twp"
        },
        {
          key: "0435",
          label: "Waterford Twp"
        },
        {
          key: "0436",
          label: "Winslow Twp"
        },
        {
          key: "0437",
          label: "Woodlynne Boro"
        }

      ]
    },
    {
      key: "05",
      label: "Cape May",
      active: CountyActiveStatus.FALSE,
      municipalities: [
        {
          key: "0501",
          label: "Avalon Boro"
        },
        {
          key: "0502",
          label: "Cape May City"
        },
        {
          key: "0503",
          label: "Cape May Point Boro"
        },
        {
          key: "0504",
          label: "Dennis Twp"
        },
        {
          key: "0505",
          label: "Lower Twp"
        },
        {
          key: "0506",
          label: "Middle Twp"
        },
        {
          key: "0507",
          label: "North Wildwood City"
        },
        {
          key: "0508",
          label: "Ocean City City"
        },
        {
          key: "0509",
          label: "Sea Isle City City"
        },
        {
          key: "0510",
          label: "Stone Harbor Boro"
        },
        {
          key: "0511",
          label: "Upper Twp"
        },
        {
          key: "0512",
          label: "West Boro"
        },
        {
          key: "0513",
          label: "West Wildwood Boro"
        },
        {
          key: "0514",
          label: "Wildwood City"
        },
        {
          key: "0515",
          label: "Wildwood Crest Boro"
        },
        {
          key: "0516",
          label: "Woodbine Boro"
        }

      ]
    },
    {
      key: "06",
      label: "Cumberland",
      active: CountyActiveStatus.FALSE,
      municipalities: [
        {
          key: "0601",
          label: "Bridgeton City"
        },
        {
          key: "0602",
          label: "Commercial Twp"
        },
        {
          key: "0603",
          label: "Deerfield Twp"
        },
        {
          key: "0604",
          label: "Downe Twp"
        },
        {
          key: "0605",
          label: "Fairfield Twp"
        },
        {
          key: "0606",
          label: "Greenwich Twp"
        },
        {
          key: "0607",
          label: "Hopewell Twp"
        },
        {
          key: "0608",
          label: "Lawrence Twp"
        },
        {
          key: "0609",
          label: "Maurice River Twp"
        },
        {
          key: "0610",
          label: "Millville City"
        },
        {
          key: "0611",
          label: "Shiloh Boro"
        },
        {
          key: "0612",
          label: "Stow Creek Twp"
        },
        {
          key: "0613",
          label: "Upper Deerfield Twp"
        },
        {
          key: "0614",
          label: "Vineland City"
        }

      ]
    },
    {
      key: "07",
      label: "Essex",
      active: CountyActiveStatus.FALSE,
      municipalities: [
        {
          key: "0701",
          label: "Belleville Twp"
        },
        {
          key: "0702",
          label: "Bloomfield Twp"
        },
        {
          key: "0703",
          label: "Caldwell Boro Twp"
        },
        {
          key: "0704",
          label: "Cedar Grove Twp"
        },
        {
          key: "0705",
          label: "East Orange City"
        },
        {
          key: "0706",
          label: "Essex Fells Twp"
        },
        {
          key: "0707",
          label: "Fairfield Twp"
        },
        {
          key: "0708",
          label: "Glen Ridge Boro"
        },
        {
          key: "0709",
          label: "Irvington Twp"
        },
        {
          key: "0710",
          label: "Livingston Twp"
        },
        {
          key: "0711",
          label: "Maplewood Twp"
        },
        {
          key: "0712",
          label: "Millburn Twp"
        },
        {
          key: "0713",
          label: "Montclair Twp"
        },
        {
          key: "0714",
          label: "Newark City"
        },
        {
          key: "0715",
          label: "North Caldwell Twp"
        },
        {
          key: "0716",
          label: "Nutley Twp"
        },
        {
          key: "0717",
          label: "Orange City Twp"
        },
        {
          key: "0718",
          label: "Roseland Boro"
        },
        {
          key: "0719",
          label: "South Orange Village Tw"
        },
        {
          key: "0720",
          label: "Verona Twp"
        },
        {
          key: "0721",
          label: "West Caldwell Twp"
        },
        {
          key: "0722",
          label: "West Orange Twp"
        }

      ]
    },
    {
      key: "08",
      label: "Gloucester",
      active: CountyActiveStatus.FALSE,
      municipalities: [
        {
          key: "0801",
          label: "Clayton Boro"
        },
        {
          key: "0802",
          label: "Deptford Twp"
        },
        {
          key: "0803",
          label: "East Greenwich Twp"
        },
        {
          key: "0804",
          label: "Elk Twp"
        },
        {
          key: "0805",
          label: "Franklin Twp"
        },
        {
          key: "0806",
          label: "Glassboro Boro"
        },
        {
          key: "0807",
          label: "Greenwich Twp"
        },
        {
          key: "0808",
          label: "Harrison Twp"
        },
        {
          key: "0809",
          label: "Logan Twp"
        },
        {
          key: "0810",
          label: "Mantua Twp"
        },
        {
          key: "0811",
          label: "Monroe Twp"
        },
        {
          key: "0812",
          label: "National Park Boro"
        },
        {
          key: "0813",
          label: "Newfield Boro"
        },
        {
          key: "0814",
          label: "Paulsboro Boro"
        },
        {
          key: "0815",
          label: "Pitman Boro"
        },
        {
          key: "0816",
          label: "So Harrison Twp"
        },
        {
          key: "0817",
          label: "Swedesboro Boro"
        },
        {
          key: "0818",
          label: "Washington Twp"
        },
        {
          key: "0819",
          label: "Wenonah Boro"
        },
        {
          key: "0820",
          label: "West Deptford Twp"
        },
        {
          key: "0821",
          label: "Westville Boro"
        },
        {
          key: "0822",
          label: "Woodbury City"
        },
        {
          key: "0823",
          label: "Woodbury Heights Boro"
        },
        {
          key: "0824",
          label: "Woolwich Twp"
        }

      ]
    },
    {
      key: "09",
      label: "Hudson",
      active: CountyActiveStatus.FALSE,
      municipalities: [
        {
          key: "0901",
          label: "Bayonne City"
        },
        {
          key: "0902",
          label: "East Newark Boro"
        },
        {
          key: "0903",
          label: "Guttenberg Town"
        },
        {
          key: "0904",
          label: "Harrison Town"
        },
        {
          key: "0905",
          label: "Hoboken City"
        },
        {
          key: "0906",
          label: "Jersey City City"
        },
        {
          key: "0907",
          label: "Kearny Town"
        },
        {
          key: "0908",
          label: "North Bergen Twp"
        },
        {
          key: "0909",
          label: "Secaucus Town"
        },
        {
          key: "0910",
          label: "Union City City"
        },
        {
          key: "0911",
          label: "Weehawken Twp"
        },
        {
          key: "0912",
          label: "West New York Town"
        }

      ]
    },
    {
      key: "10",
      label: "Hunterdon",
      active: CountyActiveStatus.FALSE,
      municipalities: [
        {
          key: "1001",
          label: "Alexandria Twp"
        },
        {
          key: "1002",
          label: "Bethlehem Twp"
        },
        {
          key: "1003",
          label: "Bloomsbury Boro"
        },
        {
          key: "1004",
          label: "Califon Boro"
        },
        {
          key: "1005",
          label: "Clinton Town"
        },
        {
          key: "1006",
          label: "Clinton Twp"
        },
        {
          key: "1007",
          label: "Delaware Twp"
        },
        {
          key: "1008",
          label: "East Amwell Twp"
        },
        {
          key: "1009",
          label: "Flemington Boro"
        },
        {
          key: "1010",
          label: "Franklin Twp"
        },
        {
          key: "1011",
          label: "Frenchtown Boro"
        },
        {
          key: "1012",
          label: "Glen Gardner Boro"
        },
        {
          key: "1013",
          label: "Hampton Boro"
        },
        {
          key: "1014",
          label: "High Bridge Boro"
        },
        {
          key: "1015",
          label: "Holland Twp"
        },
        {
          key: "1016",
          label: "Kingwood Twp"
        },
        {
          key: "1017",
          label: "Lambertville City"
        },
        {
          key: "1018",
          label: "Lebanon Boro"
        },
        {
          key: "1019",
          label: "Lebanon Twp"
        },
        {
          key: "1020",
          label: "Milford Boro"
        },
        {
          key: "1021",
          label: "Raritan Twp"
        },
        {
          key: "1022",
          label: "Readington Twp"
        },
        {
          key: "1023",
          label: "Stockton Boro"
        },
        {
          key: "1024",
          label: "Tewksbury Twp"
        },
        {
          key: "1025",
          label: "Union Twp"
        },
        {
          key: "1026",
          label: "West Amwell Twp"
        }

      ]
    },
    {
      key: "11",
      label: "Mercer",
      active: CountyActiveStatus.FALSE,
      municipalities: [
        {
          key: "1101",
          label: "East Windsor Twp"
        },
        {
          key: "1102",
          label: "Ewing Twp"
        },
        {
          key: "1103",
          label: "Hamilton Twp"
        },
        {
          key: "1104",
          label: "Hightstown Boro"
        },
        {
          key: "1105",
          label: "Hopewell Boro"
        },
        {
          key: "1106",
          label: "Hopewell Twp"
        },
        {
          key: "1107",
          label: "Lawrence Twp"
        },
        {
          key: "1108",
          label: "Pennington Boro"
        },
        {
          key: "1111",
          label: "Trenton City"
        },
        {
          key: "1112",
          label: "Robbinsville Twp"
        },
        {
          key: "1113",
          label: "West Windsor Twp"
        },
        {
          key: "1114",
          label: "Princeton"
        }

      ]
    },
    {
      key: "12",
      label: "Middlesex",
      active: CountyActiveStatus.TRUE,
      municipalities: [
        {
          key: "1201",
          label: "Carteret Boro"
        },
        {
          key: "1202",
          label: "Cranbury Twp"
        },
        {
          key: "1203",
          label: "Dunellen Boro"
        },
        {
          key: "1204",
          label: "East Brunswick Twp"
        },
        {
          key: "1205",
          label: "Edison Twp"
        },
        {
          key: "1206",
          label: "Helmetta Boro"
        },
        {
          key: "1207",
          label: "Highland Park Boro"
        },
        {
          key: "1208",
          label: "Jamesburg Boro"
        },
        {
          key: "1209",
          label: "Metuchen Boro"
        },
        {
          key: "1210",
          label: "Middlesex Boro"
        },
        {
          key: "1211",
          label: "Milltown Boro"
        },
        {
          key: "1212",
          label: "Monroe Twp"
        },
        {
          key: "1213",
          label: "New Brunswick City"
        },
        {
          key: "1214",
          label: "North Brunswick Twp"
        },
        {
          key: "1215",
          label: "Old Bridge Twp"
        },
        {
          key: "1216",
          label: "Perth Amboy City"
        },
        {
          key: "1217",
          label: "Piscataway Twp"
        },
        {
          key: "1218",
          label: "Plainsboro Twp"
        },
        {
          key: "1219",
          label: "Sayreville Boro"
        },
        {
          key: "1220",
          label: "South Amboy City"
        },
        {
          key: "1221",
          label: "South Brunswick Twp"
        },
        {
          key: "1222",
          label: "South Plainfield Boro"
        },
        {
          key: "1223",
          label: "South River Boro"
        },
        {
          key: "1224",
          label: "Spotswood Boro"
        },
        {
          key: "1225",
          label: "Woodbridge Twp"
        }

      ]
    },
    {
      key: "13",
      label: "Monmouth",
      active: CountyActiveStatus.FALSE,
      municipalities: [
        {
          key: "1301",
          label: "Aberdeen Twp"
        },
        {
          key: "1302",
          label: "Allenhurst Boro"
        },
        {
          key: "1303",
          label: "Allentown Boro"
        },
        {
          key: "1304",
          label: "Asbury Park City"
        },
        {
          key: "1305",
          label: "Atlantic Highlands Boro"
        },
        {
          key: "1306",
          label: "Avon By The Sea Boro"
        },
        {
          key: "1307",
          label: "Belmar Boro"
        },
        {
          key: "1308",
          label: "Bradley Beach Boro"
        },
        {
          key: "1309",
          label: "Brielle Boro"
        },
        {
          key: "1310",
          label: "Colts Neck Township"
        },
        {
          key: "1311",
          label: "Deal Boro"
        },
        {
          key: "1312",
          label: "Eatontown Boro"
        },
        {
          key: "1313",
          label: "Englishtown Boro"
        },
        {
          key: "1314",
          label: "Fair Haven Boro"
        },
        {
          key: "1315",
          label: "Farmingdale Boro"
        },
        {
          key: "1316",
          label: "Freehold Boro"
        },
        {
          key: "1317",
          label: "Freehold Twp"
        },
        {
          key: "1318",
          label: "Hazlet Twp"
        },
        {
          key: "1319",
          label: "Highlands Boro"
        },
        {
          key: "1320",
          label: "Holmdel Twp"
        },
        {
          key: "1321",
          label: "Howell Twp"
        },
        {
          key: "1322",
          label: "Interlaken Boro"
        },
        {
          key: "1323",
          label: "Keansburg Boro"
        },
        {
          key: "1324",
          label: "Keyport Boro"
        },
        {
          key: "1325",
          label: "Little Silver Boro"
        },
        {
          key: "1326",
          label: "Loch Arbour Village"
        },
        {
          key: "1327",
          label: "Long Branch City"
        },
        {
          key: "1328",
          label: "Manalapan Twp"
        },
        {
          key: "1329",
          label: "Manasquan Boro"
        },
        {
          key: "1330",
          label: "Marlboro Twp"
        },
        {
          key: "1331",
          label: "Matawan Boro"
        },
        {
          key: "1332",
          label: "Middletown Twp"
        },
        {
          key: "1333",
          label: "Millstone Twp"
        },
        {
          key: "1334",
          label: "Monmouth Beach Boro"
        },
        {
          key: "1335",
          label: "Neptune Twp"
        },
        {
          key: "1336",
          label: "Neptune City Boro"
        },
        {
          key: "1337",
          label: "Ocean Twp"
        },
        {
          key: "1338",
          label: "Oceanport Boro"
        },
        {
          key: "1339",
          label: "Red Bank Boro"
        },
        {
          key: "1340",
          label: "Roosevelt Boro"
        },
        {
          key: "1341",
          label: "Rumson Boro"
        },
        {
          key: "1342",
          label: "Sea Bright Boro"
        },
        {
          key: "1343",
          label: "Sea Girt Boro"
        },
        {
          key: "1344",
          label: "Shrewsbury Boro"
        },
        {
          key: "1345",
          label: "Shrewsbury Twp"
        },
        {
          key: "1346",
          label: "Lake Como Boro"
        },
        {
          key: "1347",
          label: "Spring Lake Boro"
        },
        {
          key: "1348",
          label: "Spring Lake Heights Bor"
        },
        {
          key: "1349",
          label: "Tinton Falls Boro"
        },
        {
          key: "1350",
          label: "Union Beach Boro"
        },
        {
          key: "1351",
          label: "Upper Freehold Twp"
        },
        {
          key: "1352",
          label: "Wall Twp"
        },
        {
          key: "1353",
          label: "West Long Branch Boro"
        }

      ]
    },
    {
      key: "14",
      label: "Morris",
      active: CountyActiveStatus.FALSE,
      municipalities: [
        {
          key: "1401",
          label: "Boonton Town"
        },
        {
          key: "1402",
          label: "Boonton Twp"
        },
        {
          key: "1403",
          label: "Butler Boro"
        },
        {
          key: "1404",
          label: "Chatham Boro"
        },
        {
          key: "1405",
          label: "Chatham Twp"
        },
        {
          key: "1406",
          label: "Chester Boro"
        },
        {
          key: "1407",
          label: "Chester Twp"
        },
        {
          key: "1408",
          label: "Denville Twp"
        },
        {
          key: "1409",
          label: "Dover Town"
        },
        {
          key: "1410",
          label: "East Hanover Twp"
        },
        {
          key: "1411",
          label: "Florham Park Boro"
        },
        {
          key: "1412",
          label: "Hanover Twp"
        },
        {
          key: "1413",
          label: "Harding Twp"
        },
        {
          key: "1414",
          label: "Jefferson Twp"
        },
        {
          key: "1415",
          label: "Kinnelon Boro"
        },
        {
          key: "1416",
          label: "Lincoln Park Boro"
        },
        {
          key: "1417",
          label: "Madison Boro"
        },
        {
          key: "1418",
          label: "Mendham Boro"
        },
        {
          key: "1419",
          label: "Mendham Twp"
        },
        {
          key: "1420",
          label: "Mine Hill Twp"
        },
        {
          key: "1421",
          label: "Montville Twp"
        },
        {
          key: "1422",
          label: "Morris Twp"
        },
        {
          key: "1423",
          label: "Morris Plains Boro"
        },
        {
          key: "1424",
          label: "Morristown Town"
        },
        {
          key: "1425",
          label: "Mountain Lakes Boro"
        },
        {
          key: "1426",
          label: "Mount Arlington Boro"
        },
        {
          key: "1427",
          label: "Mount Olive Twp"
        },
        {
          key: "1428",
          label: "Netcong Boro"
        },
        {
          key: "1429",
          label: "Parsippany Tr Hls Twp"
        },
        {
          key: "1430",
          label: "Long Hill Twp"
        },
        {
          key: "1431",
          label: "Pequannock Twp"
        },
        {
          key: "1432",
          label: "Randolph Twp"
        },
        {
          key: "1433",
          label: "Riverdale Boro"
        },
        {
          key: "1434",
          label: "Rockaway Boro"
        },
        {
          key: "1435",
          label: "Rockaway Twp"
        },
        {
          key: "1436",
          label: "Roxbury Twp"
        },
        {
          key: "1437",
          label: "Victory Gardens Boro"
        },
        {
          key: "1438",
          label: "Washington Twp"
        },
        {
          key: "1439",
          label: "Wharton Boro"
        }

      ]
    },
    {
      key: "15",
      label: "Ocean",
      active: CountyActiveStatus.FALSE,
      municipalities: [
        {
          key: "1501",
          label: "Barnegat Twp"
        },
        {
          key: "1502",
          label: "Barnegat Light Boro"
        },
        {
          key: "1503",
          label: "Bay Head Boro"
        },
        {
          key: "1504",
          label: "Beach Haven Boro"
        },
        {
          key: "1505",
          label: "Beachwood Boro"
        },
        {
          key: "1506",
          label: "Berkeley Twp"
        },
        {
          key: "1507",
          label: "Brick Twp"
        },
        {
          key: "1508",
          label: "Toms River Twp"
        },
        {
          key: "1509",
          label: "Eagleswood Twp"
        },
        {
          key: "1510",
          label: "Harvey Cedars Boro"
        },
        {
          key: "1511",
          label: "Island Heights Boro"
        },
        {
          key: "1512",
          label: "Jackson Twp"
        },
        {
          key: "1513",
          label: "Lacey Twp"
        },
        {
          key: "1514",
          label: "Lakehurst Boro"
        },
        {
          key: "1515",
          label: "Lakewood Twp"
        },
        {
          key: "1516",
          label: "Lavallette Boro"
        },
        {
          key: "1517",
          label: "Little Egg Harbor Twp"
        },
        {
          key: "1518",
          label: "Long Beach Twp"
        },
        {
          key: "1519",
          label: "Manchester Twp"
        },
        {
          key: "1520",
          label: "Mantoloking Boro"
        },
        {
          key: "1521",
          label: "Ocean Twp"
        },
        {
          key: "1522",
          label: "Ocean Gate Boro"
        },
        {
          key: "1523",
          label: "Pine Beach Boro"
        },
        {
          key: "1524",
          label: "Plumsted Twp"
        },
        {
          key: "1525",
          label: "Point Pleasant Boro"
        },
        {
          key: "1526",
          label: "Pt Pleasant Beach Boro"
        },
        {
          key: "1527",
          label: "Seaside Heights Boro"
        },
        {
          key: "1528",
          label: "Seaside Park Boro"
        },
        {
          key: "1529",
          label: "Ship Bottom Boro"
        },
        {
          key: "1530",
          label: "South Toms River Boro"
        },
        {
          key: "1531",
          label: "Stafford Twp"
        },
        {
          key: "1532",
          label: "Surf City Boro"
        },
        {
          key: "1533",
          label: "Tuckerton Boro"
        }

      ]
    },
    {
      key: "16",
      label: "Passaic",
      active: CountyActiveStatus.FALSE,
      municipalities: [
        {
          key: "1601",
          label: "Bloomingdale Boro"
        },
        {
          key: "1602",
          label: "Clifton City"
        },
        {
          key: "1603",
          label: "Haledon Boro"
        },
        {
          key: "1604",
          label: "Hawthorne Boro"
        },
        {
          key: "1605",
          label: "Little Falls Twp"
        },
        {
          key: "1606",
          label: "North Haledon Boro"
        },
        {
          key: "1607",
          label: "Passaic City"
        },
        {
          key: "1608",
          label: "Paterson City"
        },
        {
          key: "1609",
          label: "Pompton Lakes Boro"
        },
        {
          key: "1610",
          label: "Prospect Park Boro"
        },
        {
          key: "1611",
          label: "Ringwood Boro"
        },
        {
          key: "1612",
          label: "Totowa Boro"
        },
        {
          key: "1613",
          label: "Wanaque Boro"
        },
        {
          key: "1614",
          label: "Wayne Twp"
        },
        {
          key: "1615",
          label: "West Milford Twp"
        },
        {
          key: "1616",
          label: "Woodland Park Boro"
        }

      ]
    },
    {
      key: "17",
      label: "Salem",
      active: CountyActiveStatus.FALSE,
      municipalities: [
        {
          key: "1701",
          label: "Alloway Township"
        },
        {
          key: "1702",
          label: "Carneys Point Township"
        },
        {
          key: "1703",
          label: "Elmer Boro"
        },
        {
          key: "1704",
          label: "Elsinboro Twp"
        },
        {
          key: "1705",
          label: "Lower Alloway Creek Twp"
        },
        {
          key: "1706",
          label: "Mannington Twp"
        },
        {
          key: "1707",
          label: "Oldmans Twp"
        },
        {
          key: "1708",
          label: "Penns Grove Boro"
        },
        {
          key: "1709",
          label: "Pennsville Twp"
        },
        {
          key: "1710",
          label: "Pilesgrove Twp"
        },
        {
          key: "1711",
          label: "Pittsgrove Twp"
        },
        {
          key: "1712",
          label: "Quinton Twp"
        },
        {
          key: "1713",
          label: "Salem City"
        },
        {
          key: "1714",
          label: "Upper Pittsgrove Twp"
        },
        {
          key: "1715",
          label: "Woodstown Boro"
        }

      ]
    },
    {
      key: "18",
      label: "Somerset",
      active: CountyActiveStatus.ADMIN,
      municipalities: [
        {
          key: "1801",
          label: "Bedminster Twp"
        },
        {
          key: "1802",
          label: "Bernards Twp"
        },
        {
          key: "1803",
          label: "Bernardsville Boro"
        },
        {
          key: "1804",
          label: "Bound Brook Boro"
        },
        {
          key: "1805",
          label: "Branchburg Twp"
        },
        {
          key: "1806",
          label: "Bridgewater Twp"
        },
        {
          key: "1807",
          label: "Far Hills Boro"
        },
        {
          key: "1808",
          label: "Franklin Twp"
        },
        {
          key: "1809",
          label: "Green Brook Twp"
        },
        {
          key: "1810",
          label: "Hillsborough Twp"
        },
        {
          key: "1811",
          label: "Manville Boro"
        },
        {
          key: "1812",
          label: "Millstone Boro"
        },
        {
          key: "1813",
          label: "Montgomery Twp"
        },
        {
          key: "1814",
          label: "North Plainfield Boro"
        },
        {
          key: "1815",
          label: "Peapack Gladstone Boro"
        },
        {
          key: "1816",
          label: "Raritan Boro"
        },
        {
          key: "1817",
          label: "Rocky Hill Boro"
        },
        {
          key: "1818",
          label: "Somerville Boro"
        },
        {
          key: "1819",
          label: "So Bound Brook Boro"
        },
        {
          key: "1820",
          label: "Warren Twp"
        },
        {
          key: "1821",
          label: "Watchung Boro"
        }

      ]
    },
    {
      key: "19",
      label: "Sussex",
      active: CountyActiveStatus.FALSE,
      municipalities: [
        {
          key: "1901",
          label: "Andover Boro"
        },
        {
          key: "1902",
          label: "Andover Twp"
        },
        {
          key: "1903",
          label: "Branchville Boro"
        },
        {
          key: "1904",
          label: "Byram Twp"
        },
        {
          key: "1905",
          label: "Frankford Twp"
        },
        {
          key: "1906",
          label: "Franklin Boro"
        },
        {
          key: "1907",
          label: "Fredon Twp"
        },
        {
          key: "1908",
          label: "Green Twp"
        },
        {
          key: "1909",
          label: "Hamburg Boro"
        },
        {
          key: "1910",
          label: "Hampton Twp"
        },
        {
          key: "1911",
          label: "Hardyston Twp"
        },
        {
          key: "1912",
          label: "Hopatcong Boro"
        },
        {
          key: "1913",
          label: "Lafayette Twp"
        },
        {
          key: "1914",
          label: "Montague Twp"
        },
        {
          key: "1915",
          label: "Newton Town"
        },
        {
          key: "1916",
          label: "Ogdensburg Boro"
        },
        {
          key: "1917",
          label: "Sandyston Twp"
        },
        {
          key: "1918",
          label: "Sparta Twp"
        },
        {
          key: "1919",
          label: "Stanhope Boro"
        },
        {
          key: "1920",
          label: "Stillwater Twp"
        },
        {
          key: "1921",
          label: "Sussex Boro"
        },
        {
          key: "1922",
          label: "Vernon Twp"
        },
        {
          key: "1923",
          label: "Walpack Twp"
        },
        {
          key: "1924",
          label: "Wantage Twp"
        }

      ]
    },
    {
      key: "20",
      label: "Union",
      active: CountyActiveStatus.FALSE,
      municipalities: [
        {
          key: "2001",
          label: "Berkeley Heights Twp"
        },
        {
          key: "2002",
          label: "Clark Twp"
        },
        {
          key: "2003",
          label: "Cranford Twp"
        },
        {
          key: "2004",
          label: "Elizabeth City"
        },
        {
          key: "2005",
          label: "Fanwood Boro"
        },
        {
          key: "2006",
          label: "Garwood Boro"
        },
        {
          key: "2007",
          label: "Hillside Twp"
        },
        {
          key: "2008",
          label: "Kenilworth Boro"
        },
        {
          key: "2009",
          label: "Linden City"
        },
        {
          key: "2010",
          label: "Mountainside Boro"
        },
        {
          key: "2011",
          label: "New Providence Boro"
        },
        {
          key: "2012",
          label: "Plainfield City"
        },
        {
          key: "2013",
          label: "Rahway City"
        },
        {
          key: "2014",
          label: "Roselle Boro"
        },
        {
          key: "2015",
          label: "Roselle Park Boro"
        },
        {
          key: "2016",
          label: "Scotch Plains Twp"
        },
        {
          key: "2017",
          label: "Springfield Twp"
        },
        {
          key: "2018",
          label: "Summit City"
        },
        {
          key: "2019",
          label: "Union Twp"
        },
        {
          key: "2020",
          label: "Westfield Town"
        },
        {
          key: "2021",
          label: "Winfield Twp"
        }

      ]
    },
    {
      key: "21",
      label: "Warren",
      active: CountyActiveStatus.FALSE,
      municipalities: [
        {
          key: "2101",
          label: "Allamuchy Twp"
        },
        {
          key: "2102",
          label: "Alpha Boro"
        },
        {
          key: "2103",
          label: "Belvidere Town"
        },
        {
          key: "2104",
          label: "Blairstown Twp"
        },
        {
          key: "2105",
          label: "Franklin Twp"
        },
        {
          key: "2106",
          label: "Frelinghuysen Twp"
        },
        {
          key: "2107",
          label: "Greenwich Twp"
        },
        {
          key: "2108",
          label: "Hackettstown Town"
        },
        {
          key: "2109",
          label: "Hardwick Twp"
        },
        {
          key: "2110",
          label: "Harmony Twp"
        },
        {
          key: "2111",
          label: "Hope Twp"
        },
        {
          key: "2112",
          label: "Independence Twp"
        },
        {
          key: "2113",
          label: "Knowlton Twp"
        },
        {
          key: "2114",
          label: "Liberty Twp"
        },
        {
          key: "2115",
          label: "Lopatcong Twp"
        },
        {
          key: "2116",
          label: "Mansfield Twp"
        },
        {
          key: "2117",
          label: "Oxford Twp"
        },
        {
          key: "2119",
          label: "Phillipsburg Town"
        },
        {
          key: "2120",
          label: "Pohatcong Twp"
        },
        {
          key: "2121",
          label: "Washington Boro"
        },
        {
          key: "2122",
          label: "Washington Twp"
        },
        {
          key: "2123",
          label: "White Twp"
        }
      ]
    }

  ];

